import React from 'react';
import MypageEditContainer from 'containers/MypageEditContainer/MypageEditContainer';

export default function MypageEditPage() {
    return (
        <MypageEditContainer />
    )
}
